<ng-template #Modal let-data let-ref="dialogRef">
  <form #ModalForm="ngForm">
    <nb-card class="staffInfoTemplate" [nbSpinner]="info.IsLoding || aiLoading">
      <nb-card-header>
        {{ moTitle }}{{ tt('common_product_name', '商品名稱') }}
      </nb-card-header>
      <nb-card-body>
        <div class="row">
          <div class="col-sm-6 px-0">
            <div class="row mx-0 col-sm-12" *ngIf="info.moType==3 && info.orgType==1">
              <label class="label col-sm-12 col-form-label">{{ tt('product_select_store', '選擇商店') }}</label>
              <nb-select *ngIf="selectReady" name="CopyStoreID" [(ngModel)]="mealData.CopyStoreID" (selectedChange)="onSelectStore()">
                <nb-option *ngFor="let e of info.storeList" [value]="e.value">{{ e.content }}</nb-option>
              </nb-select>
            </div>

            <div class="row mx-0 col-sm-12" *ngIf="info.orgType==1 || info.orgType==3 || info.pdShowType==2">
              <label class="label col-sm-12 col-form-label">{{ tt('common_product_type', '商品種類') }}</label>
              <nb-select *ngIf="selectReady && info.isChange_Group" name="PRDGroupNo" [disabled]="info.moType == 4" [(ngModel)]="mealData.PRDGroupNo">
                <nb-option *ngFor="let e of info.groupList" [value]="e.value">{{ e.content }}</nb-option>
              </nb-select>
              <nb-select *ngIf="selectReady && !info.isChange_Group" name="PRDGroupNo" [disabled]="info.moType == 4" [(ngModel)]="mealData.PRDGroupNo">
                <nb-option *ngFor="let e of info.groupList" [value]="e.value">{{ e.content }}</nb-option>
              </nb-select>
            </div>

            <div class="row mx-0 col-sm-12" *ngIf="info.orgType==2">
              <label class="label col-sm-12 col-form-label">{{ tt('product_menu_category', '菜單分類') }}</label>
              <nb-select *ngIf="selectReady" name="PRDMenuProductGroupNo" [disabled]="info.orgType ==2 || info.moType ==4" [(ngModel)]="mealData.PRDMenuProductGroupNo">
                <nb-option *ngFor="let e of info.groupList" [value]="e.value">{{ e.content }}</nb-option>
              </nb-select>
            </div>

            <div class="row mx-0 col-sm-12">
              <label class="label col-sm-12 col-form-label required">{{ tt('common_product_name', '商品名稱') }}</label>
              <input name="ProductName" class="col-sm-12" nbInput fullWidth required autocomplete="off"
                [disabled]="info.orgType ==2 || info.moType ==4" [(ngModel)]="mealData.ProductName" />
            </div>
          </div>

          <div class="col-sm-6">
            <div class="row mx-0 col-lg-12">
              <label class="label col-sm-12 col-form-label">{{ tt('common_product_image', '商品圖片') }}</label>
              <div *ngIf="info.moType ==4" class="img-box">
                <img [src]="mealData.Image" style="width:100%">
              </div>

              <ngx-dropzone *ngIf="info.moType !=4" class="m-0 col-lg-12" [multiple]="false" (change)="onSelect($event,mealData)">
                <ngx-dropzone-label *ngIf="!mealData.Image || mealData.Image == ''">
                  {{ tt('common_upload_image_hint_1', '拖曳圖片或點擊上傳') }}<br>
                  {{ tt('common_upload_image_hint_2', '支援 jpg jpeg png') }}
                </ngx-dropzone-label>

                <ngx-dropzone-label *ngIf="mealData.Image && mealData.Image != ''">
                  <div style="position: relative;width:auto; display:inline-block">
                    <ngx-dropzone-remove-badge (click)="onRemove($event,mealData);"></ngx-dropzone-remove-badge>
                    <img [src]="mealData.Image" style="max-width: 100%; max-height: 150px;" />
                  </div>
                </ngx-dropzone-label>

                <ng-container *ngFor="let f of mealData.files">
                  <ngx-dropzone-image-preview ngProjectAs="ngx-dropzone-preview" [removable]="true"
                    (removed)="onRemove($event,mealData)" [file]="f">
                  </ngx-dropzone-image-preview>
                </ng-container>
              </ngx-dropzone>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="row mx-0 col-lg-12">
            <label class="label col-sm-12 col-form-label">{{ tt('product_multilingual_product_description', '多語言商品介紹') }}</label>
            <textarea name="ProductContant" rows="5" type="text" nbInput fullWidth
              [disabled]="info.orgType ==2 || info.moType ==4" [(ngModel)]="mealData.ProductContant"></textarea>
          </div>
        </div>

        <div class="row" *ngIf="mealData?.IsAIConentTranslate">
          <div class="row mx-0 col-lg-12">
            <div class="col-sm-12 px-0 ai-suggestion-header">
              <label class="label col-form-label m-0">AI建議 剩餘次數: {{ getAiSuggestionRemainingCount() }}</label>
              <div class="ai-suggestion-actions">
                <button nbButton size="small" status="basic" type="button" 
                  style="margin-top:5px;"
                  [nbSpinner]="aiLoading"
                  nbSpinnerSize="tiny"
                  nbSpinnerStatus="basic"
                  [disabled]="info.orgType == 2 || info.moType == 4 || aiLoading || getAiSuggestionRemainingCount() <= 0"
                  (click)="generateAiSuggestion()">
                  AI推薦
                </button>
                <button nbButton size="small" status="info" type="button"
                  style="margin-top:5px;"
                  [disabled]="info.orgType == 2 || info.moType == 4 || aiLoading || !aiSuggestionContent || aiSuggestionContent.trim() === ''"
                  (click)="applyAiSuggestion()">
                  套用
                </button>
              </div>
            </div>
            <textarea name="AiSuggestionContant" rows="5" type="text" nbInput fullWidth
              disabled [(ngModel)]="aiSuggestionContent"
              placeholder="AI 產生的商品介紹建議將顯示在這裡"></textarea>
          </div>
        </div>

        <div class="row rowTop">
          <div class="row mx-0 col-sm-6">
            <label class="label col-sm-12 col-form-label">{{ tt('common_ERP_coding', 'ERP編碼') }}</label>
            <input name="SAPProductNo" type="text" nbInput fullWidth [disabled]="info.orgType ==2 || info.moType ==4"
              [(ngModel)]="mealData.SAPProductNo" />
          </div>

          <div class="row mx-0 col-sm-6">
            <label class="label col-sm-12 col-form-label">{{ tt('report_mobile_barcode', 'Barcode') }}</label>
            <input name="Barcode" type="text" nbInput fullWidth [disabled]="info.orgType ==2 || info.moType ==4"
              [(ngModel)]="mealData.Barcode" />
          </div>
        </div>

        <div class="row rowTop">
          <div class="row mx-0 col-sm-6">
            <label class="label col-sm-12 col-form-label">外部編碼</label>
            <input name="ExternalNo" type="text" nbInput fullWidth [disabled]="info.orgType ==2 || info.moType ==4"
              [(ngModel)]="mealData.ExternalNo" />
          </div>
        </div>

        <div class="row rowTop">
          <div class="row mx-0 col-sm-6">
            <label class="label col-sm-12 col-form-label required">{{ tt('report_tax_type', '稅別') }}</label>
            <nb-select *ngIf="selectReady" name="TaxType" [(selected)]="mealData.TaxType" required [disabled]="info.orgType ==2 || info.moType ==4">
              <nb-option *ngFor="let tax of TaxTypeList" [value]="tax.value">{{ tax.content }}</nb-option>
            </nb-select>
          </div>

          <div class="row mx-0 col-sm-6" *ngIf="mealData.TaxType == 2">
            <label class="label col-sm-12 col-form-label required">{{ tt('report_tax_amount', '稅額') }}</label>
            <nb-select *ngIf="selectReady" name="TaxRate" [(selected)]="mealData.TaxRate" required disabled>
              <nb-option *ngFor="let tax of TaxRateList" [value]="tax.value">{{ tax.content }}</nb-option>
            </nb-select>
          </div>
        </div>

        <div class="row">
          <div class="row mx-0 col-sm-6">
            <label class="label col-sm-12 col-form-label required">{{ tt('common_original_price', '原價') }}</label>
            <input name="Cash" type="number" nbInput fullWidth required [disabled]="info.orgType ==2 || info.moType ==4"
              [(ngModel)]="mealData.Cash" />
          </div>

          <div class="row mx-0 col-sm-6">
            <label class="label col-sm-12 col-form-label">{{ tt('common_sum_subtotal_qty', '計入小計數量') }}</label>
            <nb-toggle name="IsSumSubtotalQty" [disabled]="info.moType ==4" [(checked)]="mealData.IsSumSubtotalQty"></nb-toggle>
          </div>
        </div>

        <div class="titleHr" *ngIf="info.pdShowType==1">
          <span>{{ title2 }}</span>
        </div>

        <div class="row" *ngIf="info.pdShowType==1">
          <div class="row mx-0 col-sm-6">
            <label class="label col-sm-12 col-form-label required">{{ tt('common_price', '售價') }}</label>
            <input name="SaleCash" type="number" nbInput fullWidth required [disabled]="info.moType ==4"
              [(ngModel)]="mealData.SaleCash" />
          </div>

          <div class="row mx-0 col-sm-6">
            <label class="label col-sm-12 col-form-label">{{ tt('common_sort', '排序') }}</label>
            <input name="Sorting" type="number" nbInput fullWidth [disabled]="info.moType ==4" [(ngModel)]="mealData.Sorting" />
          </div>
          <div class="mx-0 col-auto">
            <label class="label col-sm-12 col-form-label">{{ tt('common_change_price', '可調價') }}</label>
            <nb-toggle name="IsChangeCash" [disabled]="info.moType ==4" [(checked)]="mealData.IsChangeCash"></nb-toggle>
          </div>
        </div>

        <div class="row justify-content-between" *ngIf="info.pdShowType==1">
          <div class="mx-0 col-auto">
            <label class="label col-sm-12 col-form-label">{{ tt('common_takeout', '外帶') }}</label>
            <nb-toggle name="IsOpenTakeout" [disabled]="info.moType ==4" [(checked)]="mealData.IsOpenTakeout"></nb-toggle>
          </div>
          <div class="mx-0 col-auto">
            <label class="label col-sm-12 col-form-label">{{ tt('common_delivery', '外送') }}</label>
            <nb-toggle name="IsOpenDelivery" [disabled]="info.moType ==4" [(checked)]="mealData.IsOpenDelivery"></nb-toggle>
          </div>
          <div class="mx-0 col-auto">
            <label class="label col-sm-12 col-form-label">{{ tt('common_dine_in', '內用') }}</label>
            <nb-toggle name="IsOpenDining" [disabled]="info.moType ==4" [(checked)]="mealData.IsOpenDining"></nb-toggle>
          </div>
          <div class="mx-0 col-auto" *ngIf="info.pfType==1 || info.pfType==3 || info.pfType==4 || !info.pfType">
            <label class="label col-sm-12 col-form-label">{{ tt('common_pickup', '自取') }}</label>
            <nb-toggle name="IsOpenSelfPickup" [disabled]="info.moType==4" [(checked)]="mealData.IsOpenSelfPickup"></nb-toggle>
          </div>
        </div>

        <div class="row">
          <ng-container>
            <div class="row mx-0 col-sm-12 mt-2 justify-content-between">
              <label class="label col col-form-label text-nowrap">{{ tt('common_special_price_settings', '特殊價格設定') }}</label>
              <button nbButton class="m-0 col-12" (click)="ProductLevelSettingMO.onAddShow()" [disabled]="info.moType ==4">
                {{ tt('common_add', '新增') }}
              </button>
              <div class="w-100 mt-2">
                <table class="table table-bordered table-striped">
                  <thead>
                    <tr>
                      <th>{{ tt('common_applicable_member', '適用會員') }}</th>
                      <th style="display: none">{{ tt('common_applicable_member_id', '適用會員ID') }}</th>
                      <th style="width: 120px;">{{ tt('common_takeout_price', '外帶價') }}</th>
                      <th style="width: 120px;">{{ tt('common_delivery_price', '外送價') }}</th>
                      <th style="width: 120px;">{{ tt('common_dine_in_price', '內用價') }}</th>
                      <th style="width: 120px;">{{ tt('common_self_pickup_price', '自取價') }}</th>
                      <th style="max-width: 120px;"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let item of mealData.ProductLevelMapJsonData; let index = index; trackBy: trackByFn">
                      <td [id]="'Name'+index" style="vertical-align: middle;">{{ item.memberLevelNames }}</td>
                      <td [id]="'No'+index" style="display: none">{{ item.usrMemberLevelIDs }}</td>
                      <td style="vertical-align: middle; width: 120px;">
                        <input [name]="'memberTakeoutSaleCash' + index" type="number" [(ngModel)]="item.takeoutSaleCash" [disabled]="info.moType ==4" class="form-control" />
                      </td>
                      <td style="vertical-align: middle; width: 120px;">
                        <input [name]="'memberDeliverySaleCash' + index" type="number" [(ngModel)]="item.deliverySaleCash" [disabled]="info.moType ==4" class="form-control" />
                      </td>
                      <td style="vertical-align: middle; width: 120px;">
                        <input [name]="'memberDiningSaleCash' + index" type="number" [(ngModel)]="item.diningSaleCash" [disabled]="info.moType ==4" class="form-control" />
                      </td>
                      <td style="vertical-align: middle; width: 120px;">
                        <input [name]="'memberSelfPickupSaleCash' + index" type="number" [(ngModel)]="item.selfPickupSaleCash" [disabled]="info.moType ==4" class="form-control" />
                      </td>
                      <td style="max-width: 120px;">
                        <i class="fas fa-edit" (click)="info.moType != 4 && ProductLevelSettingMO.onOpen(item, index)">{{ tt('common_manage', '管理') }}</i>
                        <i class="fas fa-times-circle" (click)="info.moType != 4 && ProductLevelSettingMO.onDel(index)">{{ tt('common_delete', '刪除') }}</i>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </ng-container>
        </div>

        <div class="row" *ngIf="info.pfType!=1 && info.pdShowType==1">
          <div class="row mx-0 col-sm-6">
            <label class="label col-sm-12 col-form-label required">{{ tt('product_online_order_daily_supply', '線上點餐每日供應量') }}</label>
            <input name="SupplyQTY" type="number" nbInput required fullWidth max="1000000000" [disabled]="info.moType ==4" [(ngModel)]="mealData.SupplyQTY" />
          </div>
          <div class="row mx-0 col-sm-6">
            <label class="label col-sm-12 col-form-label">{{ tt('product_online_order_limit_per_order', '線上點餐每單上限數量') }}</label>
            <input name="UplimitQTY" type="number" nbInput fullWidth max="1000000000" [disabled]="info.moType ==4" [(ngModel)]="mealData.UplimitQTY" />
          </div>
        </div>

        <div class="row" *ngIf="info.pfType!=1 && info.pdShowType==1">
          <div class="row mx-0 col-lg-12">
            <label class="label col-lg-12 col-form-label">{{ tt('product_online_order_special_supply_date', '線上點餐特殊供應日期') }}</label>
            <input name="SupplyTime" class="col" nbInput fullWidth readonly [disabled]="info.moType ==4" [ngModel]="mealData.supplyDayStr" />
            <div class="pl-15" *ngIf="info.moType != 4">
              <button class="m-0" nbButton (click)="addSupplyTime()">{{ tt('common_settings', '設定') }}</button>
            </div>
          </div>
        </div>

        <div class="row" *ngIf="info.pfType!=1 && info.pdShowType==1">
          <div *ngIf="info.moType != 4" class="pr-0 col" style="max-width: 63px; align-content: flex-start">
            <label class="text-nowrap label col-lg-12 col-form-label px-0">{{ tt('product_online_order_special_supply_time', '線上點餐特殊供應時段') }}</label>
            <button nbButton class="m-0" (click)="addSupplyData()">+</button>
          </div>
          <div class="col">
            <ng-container *ngFor="let date of mealData.supplyPeriod; let i = index">
              <div *ngIf="info.moType == 4" class="row">
                <div class="row mx-0 col"><label class="label col-sm-12 col-form-label" style="height:30px"></label><input disabled class="col-sm-12" nbInput type="text" [value]="date.startTime | date : 'HH:mm'" /></div>
                <div class="row mx-0 col-auto px-0"><label class="label col-sm-12 col-form-label px-0" style="height:30px"></label><span>~</span></div>
                <div class="row mx-0 col"><label class="label col-sm-12 col-form-label" style="height:30px"></label><input disabled class="col-sm-12" nbInput type="text" [value]="date.endTime | date : 'HH:mm'" /></div>
              </div>
              <div *ngIf="info.moType != 4" class="row">
                <div class="row mx-0 col">
                  <label class="label col-sm-12 col-form-label" [style.height]="i==0 ? '30px' : 'auto'"></label>
                  <input readonly type="text" fullWidth nbInput class="col-sm-12" [name]="'ST'+i" [(ngModel)]="date.startTime" [nbTimepicker]="timepickerST" />
                  <nb-timepicker #timepickerST></nb-timepicker>
                </div>
                <div class="row mx-0 col-auto px-0"><label class="label col-sm-12 col-form-label px-0" [style.height]="i==0 ? '30px' : 'auto'"></label><span>~</span></div>
                <div class="row mx-0 col">
                  <label class="label col-sm-12 col-form-label" [style.height]="i==0 ? '30px' : 'auto'"></label>
                  <input readonly type="text" fullWidth nbInput class="col-sm-12" [name]="'ET'+i" [(ngModel)]="date.endTime" [nbTimepicker]="timepickerET" />
                  <nb-timepicker #timepickerET></nb-timepicker>
                </div>
                <div><label class="label col-sm-12 col-form-label" [style.height]="i==0 ? '30px' : 'auto'"></label><button nbButton class="" (click)="delSupplyData(i)">X</button></div>
              </div>
            </ng-container>
          </div>
        </div>

        <div class="row" *ngIf="info.moType != 4">
          <div class="pr-0 col">
            <label class="text-nowrap label col-lg-12 col-form-label px-0">{{ tt('common_addon_item_category', '附加品項') }}</label>
            <button nbButton (click)="SelectAttMMO.onOpen()" class="mr-3">{{ tt('common_add_addon_from_category', '從分類中加入附加品項') }}</button>
            <button nbButton (click)="SelectAttGM.onOpen()" class="mr-3">{{ tt('common_add_addon_item', '新增附加品項') }}</button>
          </div>
        </div>

        <div class="row mx-0 mt-3" *ngIf="mealData.AttachItemGroupJsonDatas && mealData.AttachItemGroupJsonDatas.length>0">
          <table class="table table-bordered table-striped">
            <thead>
              <tr>
                <th>{{ tt('common_sort', '排序') }}</th>
                <th>{{ tt('common_addon_group_title', '附加品項群組標題') }}</th>
                <th>{{ tt('common_option_type', '選項類型') }}</th>
                <th>{{ tt('common_required', '必選') }}</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of mealData.AttachItemGroupJsonDatas; let index = index">
                <td style="vertical-align: middle;">
                  <input nbInput type="number" *ngIf="info.moType != 4" [name]="'AttSorting_'+index" min="0" [(ngModel)]="item.Sorting" style="width: 80px">
                  <span *ngIf="info.moType==4">{{ item.Sorting }}</span>
                </td>
                <td style="vertical-align: middle;">{{ item.GroupName }}</td>
                <td style="vertical-align: middle;">{{ item.AttachItemKindName }}</td>
                <td style="vertical-align: middle;">{{ item.IsRequiredName }}</td>
                <td>
                  <i class="fas fa-search" (click)="EditAttachGMO.onOpen(4,item)">{{ tt('common_view', '查看') }}</i>
                  <i *ngIf="info.moType != 4" class="fas fa-times-circle" (click)="DelAttachG(index)">{{ tt('common_delete', '刪除') }}</i>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </nb-card-body>
      <nb-card-footer>
        <button *ngIf="info.moType != 4" nbButton (click)="onSave()" [disabled]="ModalForm.invalid">{{ tt('common_save', '儲存') }}</button>
        <button nbButton (click)="ref.close()">{{ tt('common_close', '關閉') }}</button>
      </nb-card-footer>
    </nb-card>
  </form>
</ng-template>

<ng-template #DayModal let-data let-ref="dialogRef">
  <nb-card class="staffInfoTemplate">
    <nb-card-header>{{ tt('common_set_supply_time', '設定供應時間') }}</nb-card-header>
    <nb-card-body>
      <div>
        <nb-checkbox [(ngModel)]="mealData.supplyTimeMonday">{{ tt('common_monday', '星期一') }}</nb-checkbox>
        <nb-checkbox [(ngModel)]="mealData.supplyTimeTuesday">{{ tt('common_tuesday', '星期二') }}</nb-checkbox>
        <nb-checkbox [(ngModel)]="mealData.supplyTimeWednesday">{{ tt('common_wednesday', '星期三') }}</nb-checkbox>
        <nb-checkbox [(ngModel)]="mealData.supplyTimeThursday">{{ tt('common_thursday', '星期四') }}</nb-checkbox>
        <nb-checkbox [(ngModel)]="mealData.supplyTimeFriday">{{ tt('common_friday', '星期五') }}</nb-checkbox>
        <nb-checkbox [(ngModel)]="mealData.supplyTimeSaturday">{{ tt('common_saturday', '星期六') }}</nb-checkbox>
        <nb-checkbox [(ngModel)]="mealData.supplyTimeSunday">{{ tt('common_sunday', '星期日') }}</nb-checkbox>
      </div>
    </nb-card-body>
    <nb-card-footer>
      <button nbButton (click)="showSupplyTime()">{{ tt('common_confirm', '確定') }}</button>
    </nb-card-footer>
  </nb-card>
</ng-template>

<app-select-attachgroup #SelectAttGMO_Tmp *ngIf="SelectAttGM.isShow" [info]="SelectAttGM.info" [orgData]="SelectAttGM.data"
  (emitList)="SelectAttGM.onSave($event)" (emitClose)="SelectAttGM.onClose($event)"></app-select-attachgroup>

<app-edit-attachgroup #EditAttachGMO_Tmp *ngIf="EditAttachGMO.isShow" [info]="EditAttachGMO.info" [orgData]="EditAttachGMO.data"
  (emitList)="EditAttachGMO.onSave($event)" (emitClose)="EditAttachGMO.onClose($event)"></app-edit-attachgroup>

<app-select-attachmoudle #SelectAttMMO_Tmp *ngIf="SelectAttMMO.isShow" [info]="SelectAttMMO.info" [orgData]="SelectAttMMO.data"
  (emitList)="SelectAttMMO.onSave($event)" (emitClose)="SelectAttMMO.onClose($event)"></app-select-attachmoudle>

<app-select-memberType #ProductLevelSettingMO_Tmp *ngIf="ProductLevelSettingMO.isShow"
  [orgData]="ProductLevelSettingMO.data" [USR_MemberLevel_IDList]="ProductLevelSettingMO.USR_MemberLevel_IDList"
  [index]="ProductLevelSettingMO.index" (emitList)="ProductLevelSettingMO.onSave($event)"
  (emitClose)="ProductLevelSettingMO.onClose($event)"></app-select-memberType>
